import { OktaAuth } from '@okta/okta-auth-js';
import { getEnv } from '@src/apis/shared';

const CALLBACK_PATH = '/authorization-code/callback';

let authClient: OktaAuth | null = null;

const getOktaAuth = (): OktaAuth => {
  if (authClient) {
    return authClient;
  }

  const oktaBaseUri = getEnv('OKTA_BASE_URI') as string;
  const oktaClientId = getEnv('OKTA_CLIENT_ID') as string;

  if (!oktaBaseUri || !oktaClientId) {
    throw new Error('Okta configuration missing: OKTA_BASE_URI and OKTA_CLIENT_ID are required');
  }

  authClient = new OktaAuth({
    issuer: `${oktaBaseUri}/oauth2/default`,
    clientId: oktaClientId,
    redirectUri: `${window.location.origin}${CALLBACK_PATH}`,
    devMode: process.env.YERDLE_ENV !== 'production',
    scopes: ['openid', 'profile', 'email'],
    responseType: 'code',
    pkce: true,
  });

  return authClient;
};

export default getOktaAuth;
